<template>
    <div class="link-auto-table-filter-timepicker" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
        <link-timepicker shape="none"
                         :type="type"
                         :color="color"
                         :size="size"
                         v-model="filterValue.startValue"
                         placeholder="开始时间"
                         suffix-icon=""
                         class="link-auto-table-filter-datepicker-start"/>
        ----
        <link-timepicker shape="none"
                         :type="type"
                         :color="color"
                         :size="size"
                         v-model="filterValue.endValue"
                         placeholder="结束时间"
                         suffix-icon=""/>
        <link-icon :icon="icon" @click="handleClear"/>
    </div>
</template>

<script>
    export default {
        name: "link-auto-table-filter-timepicker",
        props: {
            size: {type: String,},
            type: {type: String,},
            color: {type: String,},
            placeholder: {type: String, default: '搜索关键字...'},

            field: {},
            filterValue: {},
        },
        data() {
            return {
                hover: false
            }
        },
        computed: {
            icon() {
                return !!this.hover && (!!this.filterValue.startValue || !!this.filterValue.endValue) ? 'link-icon-close' : 'link-icon-time-circle'
            },
        },
        methods: {
            handleMouseEnter() {
                this.hover = true
            },
            handleMouseLeave() {
                this.hover = false
            },
            handleEnter() {
                this.$emit('confirm', {type: 'date', filtersRaw: this.getValue()});
            },
            handleClear() {
                this.filterValue.startValue = null
                this.filterValue.endValue = null
            },
            getValue() {
                const ret = []
                !!this.filterValue.startValue && ret.push({id: this.field, property: this.field, operator: '>=', value: `${this.filterValue.startValue}`,})
                !!this.filterValue.endValue && ret.push({id: this.field, property: this.field, operator: '<=', value: `${this.filterValue.endValue}`,})
                return ret
            },
        },
    }
</script>

<style lang="scss">
    .link-auto-table-filter-timepicker {
        display: flex;
        align-items: center;
        .link-auto-table-filter-timepicker-start {
            input {
                text-align: right;
            }
        }
    }
</style>
